import React from 'react';
import { Sparkles } from 'lucide-react';

// "Make one in the studio" — deep-links the Image Studio pre-filled from the
// current builder (title/eyebrow/tagline) and, when the product already exists,
// pre-targets its cover so "Set as cover" is one click. Opens a new tab so the
// builder's unsaved form state is never lost.
export default function MakeInStudioLink({
  output = 'card',
  eyebrow,
  headline,
  tagline,
  coverProductId,
  label = 'Make one in the studio',
}: {
  output?: 'banner' | 'card' | 'logo' | 'poster';
  eyebrow?: string;
  headline?: string;
  tagline?: string;
  coverProductId?: string;
  label?: string;
}) {
  const params = new URLSearchParams({ output });
  if (eyebrow) params.set('eyebrow', eyebrow);
  if (headline) params.set('headline', headline);
  if (tagline) params.set('tagline', tagline);
  if (coverProductId) params.set('cover', coverProductId);
  return (
    <a
      href={`/my-store/studio?${params.toString()}`}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1.5"
      style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--hj-beige-ink-2)', textDecoration: 'none', padding: '7px 12px', borderRadius: 999, border: '1px solid var(--hj-beige-line)', background: 'transparent' }}
    >
      {/* Paper pill: brand yellow is invisible on beige — use paper ink. */}
      <Sparkles className="w-3.5 h-3.5" style={{ color: 'var(--hj-beige-ink)' }} /> {label} →
    </a>
  );
}
